import { render } from "./Payment.vue?vue&type=template&id=743c7900&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=743c7900&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-743c7900"

export default script